var _a;
export var ERROR_FIELD_COLOR = "error.main";
export var MaintenanceModeTypes;
(function (MaintenanceModeTypes) {
    MaintenanceModeTypes["OFF"] = "off";
    MaintenanceModeTypes["SEVERE"] = "severe";
    MaintenanceModeTypes["OPTIONAL"] = "optional";
})(MaintenanceModeTypes || (MaintenanceModeTypes = {}));
export var ExternalIntegrationIds;
(function (ExternalIntegrationIds) {
    ExternalIntegrationIds[ExternalIntegrationIds["Stripe"] = 1] = "Stripe";
    ExternalIntegrationIds[ExternalIntegrationIds["ShipStation"] = 2] = "ShipStation";
    ExternalIntegrationIds[ExternalIntegrationIds["DigitalAsset"] = 3] = "DigitalAsset";
})(ExternalIntegrationIds || (ExternalIntegrationIds = {}));
export var SignUpSteps;
(function (SignUpSteps) {
    SignUpSteps["gettingStarted"] = "getting_Started";
    SignUpSteps["additionalSeats"] = "additional_Seats";
    SignUpSteps["customizeLocation"] = "customize_Location";
    SignUpSteps["payment"] = "payment";
})(SignUpSteps || (SignUpSteps = {}));
export var GLOBAL_CONSTANTS = {
    BACKEND_API: process.env.REACT_APP_BACKEND_API,
    CONTACT_US_EMAIL: process.env.REACT_APP_CONTACT_US_EMAIL,
    COOKIE_USE_LINK: process.env.REACT_APP_COOKIE_USE_LINK,
    COURSES: "/courses",
    JOB_SECRET: process.env.REACT_APP_JOB_SECRET,
    LESSONS: "/lessons",
    LOCAL_STORAGE_PREFIX: process.env.REACT_APP_LOCAL_STORAGE_PREFIX,
    LOG_URL: "/client-log",
    MAIL_ENCRYPTION_LINK_KEY: process.env.REACT_APP_MAIL_ENCRYPTION_LINK_SECRET_KEY,
    MARKETING_WEBSITE: process.env.REACT_APP_MARKETING_WEBSITE,
    PRIVACY_POLICY_LINK: process.env.REACT_APP_PRIVACY_POLICY_LINK,
    SUBJECT_CATEGORIES: "/subject-categories",
    TERMS_AND_CONDITIONS_LINK: process.env.REACT_APP_TERMS_AND_CONDITIONS_LINK,
    UPLOAD_URL: "/upload",
    UPGRADE: "/signUp/upgrade?step=".concat(SignUpSteps.gettingStarted)
};
export var LessonRanks;
(function (LessonRanks) {
    LessonRanks[LessonRanks["One"] = 1] = "One";
    LessonRanks[LessonRanks["Two"] = 2] = "Two";
    LessonRanks[LessonRanks["Three"] = 3] = "Three";
})(LessonRanks || (LessonRanks = {}));
export var LessonTypes;
(function (LessonTypes) {
    LessonTypes[LessonTypes["VideoOnly"] = 1] = "VideoOnly";
    LessonTypes[LessonTypes["Interactive"] = 2] = "Interactive";
    LessonTypes[LessonTypes["TestOnly"] = 3] = "TestOnly";
})(LessonTypes || (LessonTypes = {}));
export var LessonVideoSegmentTypes;
(function (LessonVideoSegmentTypes) {
    LessonVideoSegmentTypes["Correct"] = "correct";
    LessonVideoSegmentTypes["Incorrect"] = "incorrect";
    LessonVideoSegmentTypes["Loop"] = "loop";
    LessonVideoSegmentTypes["Start"] = "start";
    LessonVideoSegmentTypes["Question"] = "displayQuestion";
})(LessonVideoSegmentTypes || (LessonVideoSegmentTypes = {}));
export var LessonVideoSegmentTypeIds;
(function (LessonVideoSegmentTypeIds) {
    LessonVideoSegmentTypeIds[LessonVideoSegmentTypeIds["Start"] = 1] = "Start";
    LessonVideoSegmentTypeIds[LessonVideoSegmentTypeIds["Loop"] = 2] = "Loop";
    LessonVideoSegmentTypeIds[LessonVideoSegmentTypeIds["Correct"] = 3] = "Correct";
    LessonVideoSegmentTypeIds[LessonVideoSegmentTypeIds["Incorrect"] = 4] = "Incorrect";
    LessonVideoSegmentTypeIds[LessonVideoSegmentTypeIds["Question"] = 5] = "Question";
})(LessonVideoSegmentTypeIds || (LessonVideoSegmentTypeIds = {}));
export var LessonVideoSegmentTypeIdMap = (_a = {},
    _a[LessonVideoSegmentTypeIds.Start] = LessonVideoSegmentTypes.Start,
    _a[LessonVideoSegmentTypeIds.Question] = LessonVideoSegmentTypes.Question,
    _a[LessonVideoSegmentTypeIds.Loop] = LessonVideoSegmentTypes.Loop,
    _a[LessonVideoSegmentTypeIds.Correct] = LessonVideoSegmentTypes.Correct,
    _a[LessonVideoSegmentTypeIds.Incorrect] = LessonVideoSegmentTypes.Incorrect,
    _a);
export var QuestionDifficultyLevels;
(function (QuestionDifficultyLevels) {
    QuestionDifficultyLevels[QuestionDifficultyLevels["VeryEasy"] = 1] = "VeryEasy";
    QuestionDifficultyLevels[QuestionDifficultyLevels["Easy"] = 2] = "Easy";
    QuestionDifficultyLevels[QuestionDifficultyLevels["Normal"] = 3] = "Normal";
    QuestionDifficultyLevels[QuestionDifficultyLevels["Hard"] = 4] = "Hard";
    QuestionDifficultyLevels[QuestionDifficultyLevels["VeryHard"] = 5] = "VeryHard";
})(QuestionDifficultyLevels || (QuestionDifficultyLevels = {}));
export var QuestionTypes;
(function (QuestionTypes) {
    QuestionTypes[QuestionTypes["SingleChoice"] = 1] = "SingleChoice";
    QuestionTypes[QuestionTypes["MultipleChoice"] = 2] = "MultipleChoice";
    QuestionTypes[QuestionTypes["FreeTextShort"] = 3] = "FreeTextShort";
    QuestionTypes[QuestionTypes["FreeTextLong"] = 4] = "FreeTextLong";
    QuestionTypes[QuestionTypes["PrioritizedMultipleChoice"] = 5] = "PrioritizedMultipleChoice";
    QuestionTypes[QuestionTypes["Grouping"] = 6] = "Grouping";
    QuestionTypes[QuestionTypes["Sequencing"] = 7] = "Sequencing";
    QuestionTypes[QuestionTypes["DragAndDrop"] = 8] = "DragAndDrop";
    QuestionTypes[QuestionTypes["CaseStudy"] = 9] = "CaseStudy";
    QuestionTypes[QuestionTypes["ClozeDropDown"] = 10] = "ClozeDropDown";
    QuestionTypes[QuestionTypes["MatrixSingleChoice"] = 11] = "MatrixSingleChoice";
    QuestionTypes[QuestionTypes["MatrixMultipleChoice"] = 12] = "MatrixMultipleChoice";
    QuestionTypes[QuestionTypes["DropDownTable"] = 13] = "DropDownTable";
    QuestionTypes[QuestionTypes["BowTie"] = 14] = "BowTie";
    QuestionTypes[QuestionTypes["MultipleChoiceSN"] = 15] = "MultipleChoiceSN";
    QuestionTypes[QuestionTypes["MultipleChoiceSATA"] = 16] = "MultipleChoiceSATA";
    QuestionTypes[QuestionTypes["MultipleResponseGroup"] = 17] = "MultipleResponseGroup";
    QuestionTypes[QuestionTypes["RationalScoringDragAndDrop"] = 18] = "RationalScoringDragAndDrop";
    QuestionTypes[QuestionTypes["RationalScoringDropDown"] = 19] = "RationalScoringDropDown";
    QuestionTypes[QuestionTypes["HotspotHighlight"] = 20] = "HotspotHighlight";
    QuestionTypes[QuestionTypes["HighlightTable"] = 21] = "HighlightTable";
})(QuestionTypes || (QuestionTypes = {}));
export var QuestionBankTestModes;
(function (QuestionBankTestModes) {
    QuestionBankTestModes[QuestionBankTestModes["Tutor"] = 1] = "Tutor";
    QuestionBankTestModes[QuestionBankTestModes["Test"] = 2] = "Test";
    QuestionBankTestModes[QuestionBankTestModes["CAT"] = 3] = "CAT";
})(QuestionBankTestModes || (QuestionBankTestModes = {}));
export var UserTypes;
(function (UserTypes) {
    UserTypes[UserTypes["Admin"] = 1] = "Admin";
    UserTypes[UserTypes["RegularStudent"] = 2] = "RegularStudent";
})(UserTypes || (UserTypes = {}));
export var UserAuthTypes;
(function (UserAuthTypes) {
    UserAuthTypes[UserAuthTypes["Normal"] = 1] = "Normal";
    UserAuthTypes[UserAuthTypes["GoogleLogin"] = 2] = "GoogleLogin";
    UserAuthTypes[UserAuthTypes["FacebookLogin"] = 3] = "FacebookLogin";
})(UserAuthTypes || (UserAuthTypes = {}));
export var UserSubscriptionTypeCategoriesEnum;
(function (UserSubscriptionTypeCategoriesEnum) {
    UserSubscriptionTypeCategoriesEnum[UserSubscriptionTypeCategoriesEnum["Course"] = 1] = "Course";
    UserSubscriptionTypeCategoriesEnum[UserSubscriptionTypeCategoriesEnum["LocationPackage"] = 2] = "LocationPackage";
    UserSubscriptionTypeCategoriesEnum[UserSubscriptionTypeCategoriesEnum["LocationPerSeat"] = 3] = "LocationPerSeat";
})(UserSubscriptionTypeCategoriesEnum || (UserSubscriptionTypeCategoriesEnum = {}));
export var LocationPackagesTypeEnum;
(function (LocationPackagesTypeEnum) {
    LocationPackagesTypeEnum[LocationPackagesTypeEnum["Package1"] = 1] = "Package1";
    LocationPackagesTypeEnum[LocationPackagesTypeEnum["Package2"] = 2] = "Package2";
    LocationPackagesTypeEnum[LocationPackagesTypeEnum["Package12"] = 3] = "Package12";
})(LocationPackagesTypeEnum || (LocationPackagesTypeEnum = {}));
export var UserPaymentType;
(function (UserPaymentType) {
    UserPaymentType[UserPaymentType["Subscription"] = 1] = "Subscription";
    UserPaymentType[UserPaymentType["Book"] = 2] = "Book";
    UserPaymentType[UserPaymentType["CAT"] = 3] = "CAT";
    UserPaymentType[UserPaymentType["LocationSeat"] = 4] = "LocationSeat";
    UserPaymentType[UserPaymentType["LocationTheme"] = 5] = "LocationTheme";
    UserPaymentType[UserPaymentType["InvitedUser"] = 6] = "InvitedUser";
})(UserPaymentType || (UserPaymentType = {}));
export var UserCustomTestTypes;
(function (UserCustomTestTypes) {
    UserCustomTestTypes[UserCustomTestTypes["Tutor"] = 1] = "Tutor";
    UserCustomTestTypes[UserCustomTestTypes["Test"] = 2] = "Test";
    UserCustomTestTypes[UserCustomTestTypes["CAT"] = 3] = "CAT";
})(UserCustomTestTypes || (UserCustomTestTypes = {}));
export var QuestionDifficultyLevelTiers;
(function (QuestionDifficultyLevelTiers) {
    QuestionDifficultyLevelTiers[QuestionDifficultyLevelTiers["Easy"] = 1] = "Easy";
    QuestionDifficultyLevelTiers[QuestionDifficultyLevelTiers["Moderate"] = 2] = "Moderate";
    QuestionDifficultyLevelTiers[QuestionDifficultyLevelTiers["Hard"] = 3] = "Hard";
})(QuestionDifficultyLevelTiers || (QuestionDifficultyLevelTiers = {}));
export var SET_START = "setStart";
export var SET_LOOP = "setLoop";
export var SET_CORRECT_RES = "setCorrectRes";
export var SET_INCORRECT_RES = "setIncorrectRes";
export var PREVIEW = "preview";
export var actionKey = [SET_START, SET_LOOP, SET_CORRECT_RES, SET_INCORRECT_RES, PREVIEW];
export var FROM = "from";
export var TO = "to";
export var MAX_GROUPING_ANSWER_OPTIONS = 9;
export var MAX_TESTONLY_QUESTION_TYPES_OPTS_LENGTH = 6;
export var MAX_COURSE_ADDONS = 10;
export var MAX_VIT_ANSWER_OPTIONS = 5;
export var MAX_ANSWER_OPTIONS_TEXT_LENGTH = 35;
export var CUSTOM_MAX_ANSWER_OPTIONS_TEXT_LENGTH = 20;
export var MAX_GROUP_TEXT_LENGTH = 90;
export var MAX_TAB_CHARACTER_LENGTH = 15;
export var YYYY_MM_DD = "yyyy-MM-dd";
export var KK_MM_AA = "KK:mm aa";
export var COUNTDOWN_STATUS = {
    STARTED: "Started",
    STOPPED: "Stopped"
};
//# sourceMappingURL=constants.js.map